import React from "react";
import { Pill, Activity, ShieldCheck, HeartPulse, RefreshCw } from "lucide-react";
import type { ClinicalApplication } from '../types/home.types';
import { GlowingEffect } from '@/components/ui/glowing-effect';

const icons = [Pill, Activity, ShieldCheck, HeartPulse, RefreshCw];

interface ClinicalApplicationsListProps {
  applications: ClinicalApplication[];
}

export const ClinicalApplicationsList = React.memo(({ applications }: ClinicalApplicationsListProps) => {
  return (
    <div className="space-y-8">
      <div className="flex flex-wrap justify-center gap-4 sm:gap-5">
        {applications.map((app, index) => {
          const Icon = icons[index];
          return (
            <div
              key={index}
              className="group relative flex flex-row sm:flex-col items-center sm:text-center text-left rounded-xl bg-white border border-neutral-200 
                p-4 sm:p-6 gap-4 sm:gap-0
                hover:shadow-lg hover:border-[hsl(var(--color-1)/0.35)] hover:-translate-y-1
                transition-all duration-400 ease-out
                w-full sm:w-[calc(50%-0.625rem)] lg:w-[calc(33.333%-0.875rem)]"
            >
              <div className="w-11 h-11 sm:w-12 sm:h-12 shrink-0 rounded-lg sm:rounded-full bg-gradient-to-br from-[hsl(var(--color-3))] to-[hsl(var(--color-1))] flex items-center justify-center sm:mb-4 transition-transform duration-300 group-hover:scale-105">
                <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-white" strokeWidth={1.8} />
              </div>
              <p className="text-[0.9375rem] sm:text-base font-light leading-relaxed text-foreground font-inter">
                {app.text}
              </p>
            </div>
          );
        })}
      </div>

      {/* Summary */}
      <div className="group relative rounded-2xl border border-neutral-200 p-2 md:p-3 transition-all duration-300 hover:border-[hsl(var(--color-1)/0.45)] hover:shadow-[0_0_20px_4px_hsl(var(--color-1)/0.08)]">
        <GlowingEffect 
          spread={40}
          glow={true}
          disabled={false}
          proximity={64}
          inactiveZone={0.01}
        />
        <div className="relative rounded-xl border border-neutral-100 bg-white p-6 sm:p-7 transition-all duration-300 group-hover:border-[hsl(var(--color-1)/0.15)]">
          <p className="leading-relaxed text-foreground font-inter text-center text-base sm:text-lg font-light">
            With Xenira's expertise in advanced lipid-based delivery systems and proprietary innovations, partners gain a reliable platform to bring differentiated, patient-friendly therapies to market.
          </p>
        </div>
      </div>
    </div>
  );
});

ClinicalApplicationsList.displayName = 'ClinicalApplicationsList';
